import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconCheckCircle } from '@change-corgi/design-system-legacy/icons';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

export function EducationModalHeading(): JSX.Element {
	return (
		<Flex sx={{ alignItems: 'baseline', marginRight: 32 }}>
			<Icon icon={iconCheckCircle} size="xl" color="typography-positive" mr={8} sx={{ flexShrink: 0 }} />
			<Heading as="h1" size="h3">
				<Translate value="fe.components.psf.instagram.link_copied" />
			</Heading>
		</Flex>
	);
}
